import React from "react";

import "./DateContainer.css";
import { observer } from "mobx-react-lite";
import { DateInfo } from "../../../../types/types";
import { useCreateLeagueMatchStore } from "../../../../store/StoreContext";
import { Colors } from "../../../../utils/colors";
import { TCText } from "../../../../components/tcText/TCText";

type props = {
  dateInfo: DateInfo;
};

export const DateContainer: React.FC<props> = observer(({ dateInfo }) => {
  const createLeagueMatchStore = useCreateLeagueMatchStore();

  return (
    <div
      style={{
        minWidth: 56,
        height: 64,
        borderRadius: 16,
        backgroundColor:
          createLeagueMatchStore.selectedDate === dateInfo
            ? Colors.green
            : Colors.lightGreyBackground,
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
      onClick={() => {
        createLeagueMatchStore.setSelectedDate(dateInfo);
      }}>
      <div>
        <TCText
          style={{
            color:
              createLeagueMatchStore.selectedDate === dateInfo
                ? "white"
                : Colors.grey,
            textAlign: "center",
          }}
          className="date-container-day"
          value={dateInfo.day}
        />
        <TCText
          style={{
            color:
              createLeagueMatchStore.selectedDate === dateInfo
                ? "white"
                : Colors.grey,
            textAlign: "center",
          }}
          className="date-container-date"
          value={dateInfo.date}
        />
        <TCText
          style={{
            color:
              createLeagueMatchStore.selectedDate === dateInfo
                ? "white"
                : Colors.grey,
            textAlign: "center",
          }}
          className="date-container-month"
          value={dateInfo.month}
        />
      </div>
    </div>
  );
});
